export default __webpack_public_path__ + "static/Home-15fe4bd3eec5310eae2c2be257c27d4b.png";